const ENDPOINT = '/api/events'

export function track(name, properties = {}) {
  if (typeof window === 'undefined' || navigator.doNotTrack === '1') return
  const body = JSON.stringify({ name, properties })
  try {
    if (navigator.sendBeacon) {
      const payload = new Blob([body], { type: 'application/json' })
      if (navigator.sendBeacon(ENDPOINT, payload)) return
    }
    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {})
  } catch {
    // La mesure ne doit jamais gêner le jeu.
  }
}
